<template>
  <div>
    <NBar title="游戏币名称" :top="true"/>
    <div class="subject">
      <div class="card">
        <div class="card-header">
          <img class="card-img" :src="require('@/resource/img/device/headerImg.png')">
          <span>余币：0</span>
        </div>
        <div class="card-text">编辑【余币】名称，在使用过程中传播品牌</div>
        <nut-textinput v-model="val" placeholder="请输入(限3个字)" :clearBtn="true" :disabled="false"
                       class="input"/>
      </div>
      <nut-button block class="btn">保存</nut-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GameCurrencyName',
  data () {
    return {
      val: ''
    }
  }
}
</script>

<style scoped>
  .subject {
    margin: 0 15px;
  }

  .subject .card {
    margin: 15px;
    height: 150px;
    background: #fff;
    box-shadow: 2px 2px 6px 0 #e3e2e9;
    border-radius: 4px;
    padding: 15px 10px 10px;
  }

  .subject .card .card-header {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .subject .card .card-img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 10px;
  }

  .subject .card .card-text {
    text-align: center;
    color: #676767;
    margin: 10px 0 15px 0;
  }

  .subject .input {
    margin: 5px 0;
  }

  .subject .btn {
    margin-top: 10px;
    border-radius: 5px;
  }

  >>> .nut-button {
    background: #409EFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/device/userInfo/accounts/GameCurrencyName.vue